import { Injectable } from '@angular/core'
import { MatDialogConfig } from '@angular/material/dialog'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { Guest } from '@tv3/store/guest/guest.model'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import { InitialWhatsappDialogComponent } from './initial-whatsapp-dialog.component'
import { VendorResponse } from '@tokeet-frontend/vendors'

@Injectable()
export class InitialWhatsappDialogService {
  constructor(private dialog: DialogService) {}

  public open(data: { guest?: Guest; vendor?: VendorResponse; inquiry?: Inquiry }) {
    const defaultConfig: MatDialogConfig = {
      width: '650px',
      height: 'auto',
      data: { ...data },
    }

    return this.dialog.openVariableDialog(InitialWhatsappDialogComponent, defaultConfig)
  }
}
